import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { IItemConfigSet } from "../interfaces/iitemconfig";
import { ItemConfigService } from "../services/itemconfig.service";

@Injectable()
export class CountryResolver implements Resolve<IItemConfigSet> {
    constructor(private itemConfigService: ItemConfigService) {}

    resolve(route:ActivatedRouteSnapshot): Observable<IItemConfigSet> {
         return this.itemConfigService.getConfigSetByCountry(route.params["countryCode"]);
    }
}

